export default "__VITE_ASSET__DW7Y6ZGC__"